/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-11-30 18:52:07
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import { post, get } from 'src/api/http';
import types from './type';

class NetWorkMgnt {
    pingResult (data:types.PingResultParams): Promise<types.PingResultData> {
        return post('/amr/network-management/ping-result', data);
    }
    getLinkTimes (data: types.LinkTimesParams): Promise<types.LinkTimesList[]> {
        return post('/amr/network-management/link-times', data);
    }
    initData (data: types.InitDataParams): Promise<types.InitDataList> {
        return post('/amr/network-management/init-data', data);
    }
    getCensus (data:types.CensusParams): Promise<types.CensusData> {
        return post('/amr/network-management/census', data);
    }
    getPhaseCensus (data: types.PhaseCensusParams): Promise<types.PhaseCensusData> {
        return post('/amr/network-management/phase-census', data);
    }
    getMeterList (data: types.MeterListParams): Promise<types.InitDataList> {
        return post('/amr/network-management/meter-list', data);
    }
    getBelongToMeterList (dcuNo:string): Promise<types.ToMeterListData> {
        return post(`/amr/network-management/belong-to-meter-list?dcuNo=${dcuNo}`);
    }
    exePing (data: types.ExePingParams): Promise<types.ExePingData> {
        return post('/amr/network-management/exe-ping', data);
    }
    getMeterHistoryData (data: types.HistoryDataParams): Promise<types.HistoryData> {
        return post('/amr/network-management/meter-history-data', data);
    }
    getTopologyPolicy (): Promise<types.TopologyPolicy> {
        return get('/amr/network-management/read-topology-policy');
    }
    saveTopologyPolicy (data: types.SaveTopologyPolicyParam): Promise<boolean> {
        return post('/amr/network-management/save-read-topology-policy', data);
    }
    createTopologyTask (cstId: string): Promise<string> {
        return post('/amr/network-management/read-topology', {cstId});
    }
    getTopologyByMeter (meterNo: string): Promise<types.QueryTopologyByMeterData> {
        return get('/amr/network-management/topology-by-meter', {meterNo});
    }
}

export default new NetWorkMgnt();
